import React from "react";
import { Table } from "@themesberg/react-bootstrap";

const LABELS = {
  JACKPOT: "Jackpot", FIRST: "Giải Nhất", SECOND: "Giải Nhì",
  THIRD: "Giải Ba", FOURTH: "Giải Tư", FIFTH: "Giải Năm", SIXTH: "Khuyến khích",
};
const money = (value) => String(value ?? "0").replace(/\B(?=(\d{3})+(?!\d))/g, ".");

export default function Lotto535RewardTable({ numberRows = [] }) {
  return <Table responsive bordered size="sm">
    <thead><tr><th>Dãy số</th><th>Hạng giải</th><th>Số bộ trúng</th><th>Mức trả</th><th>Hệ số</th><th>Thành tiền</th></tr></thead>
    <tbody>{numberRows.flatMap((row) => {
      const details = row.rewardBreakdowns || [];
      if (!details.length) return [<tr key={row.id}><td>{row.numbers}</td><td colSpan="5" className="text-muted">Không trúng</td></tr>];
      return details.map((detail, index) => <tr key={detail.id || `${row.id}-${detail.tierCode}`}>
        {index === 0 && <td rowSpan={details.length}>{row.numbers}</td>}
        <td>{LABELS[detail.tierCode] || detail.tierCode}</td>
        <td>{detail.winningCombinationCount}</td><td>{money(detail.unitPrizeAmount)}đ</td>
        <td>x{detail.stakeMultiplier}</td><td><b>{money(detail.grossAmount)}đ</b></td>
      </tr>);
    })}</tbody>
  </Table>;
}
